
import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";

@Component({
  selector: 'app-complete-order-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule
],
  template: `
<div [class]="data.class + ' bg-back text-copy ' ">
  <div class="bg-gold-500 font-bold flex items-center justify-between py-4 px-6">
    <span>{{ action }} {{ item }}</span>
    <!--<mat-icon (click)="dialogRef.close()">close</mat-icon>-->
  </div>
  <div mat-dialog-content>
    @for (information of info; track information) {
      <p>{{information}}</p>
    }
  </div>
  <div class="bg-copy/10 flex justify-between py-4 px-6">
    <button mat-flat-button [mat-dialog-close]="false">{{close}}</button>
    @if (action) {
      <button mat-flat-button color="warn" [mat-dialog-close]="true">{{action}}</button>
    }
  </div>

</div>
`,
  styles: ['']
})
export class ConfirmDeleteDialogComponent implements OnInit {
  close = 'Close';
  item = 'Order';
  action = 'To Be Cancelled';
  info:string[] = []

  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteDialogData
  ) { }

  ngOnInit(): void {
    this.item = this.data.item || this.item;
    this.action = this.data.action !== undefined ? this.data.action : this.action;
    this.info = this.data.info || this.info;
    if(this.data.closeText){
      this.close = this.data.closeText;
    }
  }

}

export interface ConfirmDeleteDialogData {
  class: string
  closeText?: string
  item?: string
  info: string[]
  action?: string
}

